import React, { useEffect, useRef } from 'react';

// Chargement unique de l'API officielle YouTube IFrame
let ytApiPromise = null;
const loadYT = () => {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (!ytApiPromise) {
    ytApiPromise = new Promise((resolve) => {
      const prev = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => { if (prev) prev(); resolve(window.YT); };
      const s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    });
  }
  return ytApiPromise;
};

export const extractYtId = (s) => {
  if (!s) return null;
  const m = s.match(/(?:embed\/|shorts\/|watch\?v=|youtu\.be\/)([\w-]{6,})/);
  return m ? m[1] : null;
};

export const YouTubeShortPlayer = ({ videoId, muted, paused, onEnded }) => {
  const elRef = useRef(null);
  const pRef = useRef(null);
  const readyRef = useRef(false);
  const mutedRef = useRef(muted);
  const onEndedRef = useRef(onEnded);
  mutedRef.current = muted;
  onEndedRef.current = onEnded;

  useEffect(() => {
    let cancelled = false;
    loadYT().then((YT) => {
      if (cancelled || !elRef.current) return;
      pRef.current = new YT.Player(elRef.current, {
        videoId,
        width: '100%',
        height: '100%',
        playerVars: { autoplay: 1, playsinline: 1, rel: 0, mute: 1 },
        events: {
          onReady: (e) => {
            readyRef.current = true;
            try {
              if (!mutedRef.current) { e.target.unMute(); e.target.setVolume(100); }
              e.target.playVideo();
            } catch { /* noop */ }
          },
          onStateChange: (e) => { if (e.data === 0) onEndedRef.current?.(); },
        },
      });
    });
    return () => {
      cancelled = true;
      readyRef.current = false;
      try { pRef.current?.destroy(); } catch { /* noop */ }
      pRef.current = null;
    };
  }, [videoId]);

  useEffect(() => {
    const p = pRef.current;
    if (!p || !readyRef.current) return;
    try {
      if (muted) p.mute();
      else { p.unMute(); p.setVolume(100); }
    } catch { /* noop */ }
  }, [muted]);

  useEffect(() => {
    const p = pRef.current;
    if (!p || !readyRef.current) return;
    try { if (paused) p.pauseVideo(); else p.playVideo(); } catch { /* noop */ }
  }, [paused]);

  return (
    <div className="w-full h-full [&_iframe]:w-full [&_iframe]:h-full" data-testid="shorts-youtube">
      <div ref={elRef} />
    </div>
  );
};
